import Loadable from '../../components/loadable';

const ContactNotesReport = Loadable({
  loader: () => import('../../pages/reports/contact_notes_report/contact_notes_report'),
});

angular.module('gym').value('ContactNotesReport', ContactNotesReport);

const ContactNotesReportFiltersModal = Loadable({
  loader: () =>
    import('../../pages/reports/contact_notes_report/contact_notes_report_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('ContactNotesReportFiltersModal', ContactNotesReportFiltersModal);
